"use client"

import { useEffect, useState } from "react"
import { observer } from "mobx-react-lite"
import { useAppContext } from "../../../shared/functions/Context"
import type { IValueRating } from "../../../shared/models/three-sixty-feedback-models/ValueRating"
import AdminFlagRatingsTable from "../ratings/components/AdminFlagRatingsTable"

interface ILeadershipRatings {
  overallRating: number
  id: string
  rateeId: string
  dimension: string
  isflagged: boolean
  department: string
  description: string
  userComment?: string
  adminComment?: string
  adminApproval?: string
  criteria: {
    [raterId: string]: {
      additionalComment?: string
      stopDoing: string
      startDoing: string
      continueDoing: string
      ratings: {
        [criteriaName: string]: {
          [statement: string]: number
        }
      }
      leadershipScore?: number
    }
  }
  date: number
  //Templteopionol properties
  raterId?: string
  templateId?: string
  heading?: string
  reasonForRequest?: string
  dueDate?: number
  values?: {}
  archived?: boolean
}

const FlaggedRequests = observer(() => {
  const { api, store } = useAppContext()

  const valueRatings = store.valueRating.all
    .filter(
      (rating) =>
        rating.asJson.isflagged &&
        rating.asJson.adminApproval !== "Approved for Re-rating" &&
        rating.asJson.resubmission !== "Open",
    ) // Filter to only include flagged ratings and exclude those approved by admin
    .map((l) => l.asJson)

  const leadershipRatings = store.leadershipRating.all
    .filter(
      (rating) =>
        rating.asJson.isflagged &&
        rating.asJson.adminApproval !== "Approved for Re-rating" &&
        rating.asJson.resubmission !== "Open",
    ) // Filter to only include flagged ratings
    .map((l) => l.asJson)

  const templateRatings = store.templateRating.all
    .filter(
      (rating) =>
        rating.asJson.isflagged &&
        rating.asJson.adminApproval !== "Approved for Re-rating" &&
        rating.asJson.resubmission !== "Open",
    ) // Filter to only include flagged ratings and exclude those approved by admin
    .map((l) => l.asJson)
  const [description, setDescription] = useState("")

  const mapValueToLeadership = (valueRating: IValueRating): ILeadershipRatings => {
    const mappedLeadershipRating: ILeadershipRatings = {
      id: valueRating.id, // Map id to id
      rateeId: valueRating.rateeId, // Map rateeId to rateeId
      date: valueRating.date, // Map date to date
      dimension: valueRating.dimension,
      criteria: {}, // Initialize criteria object
      overallRating: valueRating.overallRating,
      isflagged: valueRating.isflagged,
      department: valueRating.department,
      description: valueRating.description,
      userComment: valueRating.userComment,
      adminComment: valueRating.adminComment,
    }

    // Loop through each raterId in values
    Object.keys(valueRating.values).forEach((raterId) => {
      // Get the corresponding criteria name
      const criteriaName = Object.keys(valueRating.values[raterId].ratings)[0]

      // Map properties for each raterId
      mappedLeadershipRating.criteria[raterId] = {
        additionalComment: valueRating.values[raterId].additionalComment,
        stopDoing: valueRating.values[raterId].stopDoing,
        startDoing: valueRating.values[raterId].startDoing,
        continueDoing: valueRating.values[raterId].continueDoing,
        ratings: {
          [criteriaName]: valueRating.values[raterId].ratings[criteriaName],
        },
      }
    })

    return mappedLeadershipRating
  }

  const mapTemplateToLeadership = (templateRating: any): ILeadershipRatings => {
    const mappedLeadershipRating: ILeadershipRatings = {
      id: templateRating.id,
      rateeId: templateRating.rateeId,
      date: templateRating.date,
      dimension: templateRating.dimension || "Template",
      criteria: {},
      overallRating: templateRating.overallRating || 0,
      isflagged: templateRating.isflagged,
      department: templateRating.department,
      description: templateRating.description,
      userComment: templateRating.userComment,
      adminComment: templateRating.adminComment,
      adminApproval: templateRating.adminApproval,
      // Template-specific properties
      raterId: templateRating.raterId,
      templateId: templateRating.templateId,
      heading: templateRating.heading,
      reasonForRequest: templateRating.reasonForRequest,
      dueDate: templateRating.dueDate,
      values: templateRating.values,
      archived: templateRating.archived,
    }

    // If template has values, map them to criteria format
    if (templateRating.values) {
      Object.keys(templateRating.values).forEach((key) => {
        mappedLeadershipRating.criteria[key] = templateRating.values[key]
      })
    }

    return mappedLeadershipRating
  }

  const valueRates = valueRatings.map((valueRating) => {
    return mapValueToLeadership(valueRating)
  })

  const templateRates = templateRatings.map((templateRating) => {
    return mapTemplateToLeadership(templateRating)
  })

  const combinedRatings = [...valueRates, ...leadershipRatings, ...templateRates]

  useEffect(() => {
    const load = async () => {
      try {
        await api.user.getAll()
        await api.ratingAssignments.getAll()

        const users = store.user.all.map((user) => user.asJson)
        const uids = users.map((user) => user.uid)
        const descriptions = store.ratingAssignments.all.find((rating) => rating.asJson.isActive === true)?.asJson
          .description
        setDescription(descriptions ?? "")
        console.log("my description" + descriptions)

        if (descriptions) {
          await api.templateRating.getAll()
          await api.ratingAssignments.getAll()

          if (descriptions) {
            console.log("description is true")
            await api.valueRating.getAllNew(uids, descriptions)
            await api.leadershipRating.getAllNew(uids, descriptions)
          }
        }
      } catch (error) {
        console.error("Error loading APIs:", error)
      }
    }

    load()
  }, [api.valueRating, api.templateRating])

  return (
    <div>
      <div className="uk-card uk-card-default table-container">
        <AdminFlagRatingsTable data={combinedRatings} description={description} />
      </div>
    </div>
  )
})

export default FlaggedRequests
